/**
 * BinDoc brand colors - primary color palette for brand consistency
 */
export const BD_BRAND_COLOR_HEX_OPTIONS = [
  '#A7206C', // Primary Purple - Main brand color
  '#3F9846', // Secondary Green - Supporting brand color
  '#452A71', // Accent Purple - Tertiary brand color
  '#FC8B23', // Orange - Accent/highlight color
];

/**
 * Default color options - general purpose color palette
 */
export const BD_COLOR_HEX_DEFAULT_OPTIONS = [
  '#FF6900',
  '#FCB900',
  '#7BDCB5',
  '#00D084',
  '#8ED1FC',
  '#0693E3',
  '#ABB8C3',
  '#EB144C',
  '#F78DA7',
  '#9900EF'
];
